var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_369_2438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5003 9.32397H6.50033C4.10709 9.32397 2.16699 11.2641 2.16699 13.6573V39.6573C2.16699 42.0505 4.10709 43.9906 6.50033 43.9906H45.5003C47.8936 43.9906 49.8337 42.0505 49.8337 39.6573V13.6573C49.8337 11.2641 47.8936 9.32397 45.5003 9.32397Z",
    fill: "#2C2C2C",
    stroke: "#A37C4D",
    strokeWidth: 4.47917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16699 22.324H49.8337",
    stroke: "#A37C4D",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_2438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0 0.657227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.a3e385a90d3110206b38f4dfa51fe66b.svg";
export { ForwardRef as ReactComponent };